import { Card, useMediaQuery, Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useAppDispatch } from '../../redux/hooks';
import { QuantityControl } from './quantityControl';
import { CartProductDetails } from './cartProductDetails';
import { CartProductPrice } from './cartProductPrice';
import {
  addToCartAsync,
  IShoppingCartItemWithService,
  removeOneFromCartAsync,
} from '../../redux/reducers/shoppingCartReducer';

interface CartProductCardProps {
  item: IShoppingCartItemWithService;
}
export function CartProductCard({ item }: CartProductCardProps) {
  const dispatch = useAppDispatch();

  const isSmallScreen = useMediaQuery('(max-width:500px)');
  const isLargeScreen = useMediaQuery('(min-width:800px)');

  const serviceCount = item.count;
  const serviceItem = item.serviceItem;

  const addToBasket = () => {
    dispatch(addToCartAsync(item.serviceId));
  };

  const removeFromBasket = () => {
    dispatch(removeOneFromCartAsync(item.serviceId));
  };

  return (
    <>
      {serviceItem && (
        <Card
          sx={{
            borderRadius: '10px',
            height: 'auto',
            width: '100%',
            backgroundColor: 'white',
            py: '0px',
          }}
        >
          {isLargeScreen ? (
            <Grid
              container
              sx={{
                mx: '5px',
                pl: '5px',
                pr: '25px',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Grid size="grow">
                <CartProductDetails item={serviceItem} />
              </Grid>
              <Grid sx={{ width: '140px' }}>
                <QuantityControl
                  count={serviceCount}
                  onAdd={addToBasket}
                  onRemove={removeFromBasket}
                  isEditable={item.removable}
                />
              </Grid>
              <Grid
                sx={{
                  height: 'auto',
                  color: 'black',
                  fontSize: '19px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'right',
                  width: '160px',
                  textAlign: 'right',
                }}
              >
                <CartProductPrice item={serviceItem} serviceCount={serviceCount} />
              </Grid>
            </Grid>
          ) : isSmallScreen ? (
            <Grid
              container
              sx={{
                width: '100%',
                mx: '5px',
                pl: '5px',
                pr: '25px',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
              direction="column"
            >
              <Grid size={12} sx={{ width: '100%' }}>
                <CartProductDetails item={serviceItem} />
              </Grid>
              <Grid
                sx={{
                  display: 'flex',
                  width: '100%',
                  pl: '90px',
                }}
              >
                <QuantityControl
                  count={serviceCount}
                  onAdd={addToBasket}
                  onRemove={removeFromBasket}
                  isEditable={item.removable}
                />
              </Grid>
              <Grid
                sx={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'center',
                }}
              >
                <Box
                  sx={{
                    height: 'auto',
                    color: 'black',
                    fontSize: '19px',
                    width: '160px',
                    mb: '10px',
                  }}
                >
                  <CartProductPrice item={serviceItem} serviceCount={serviceCount} />
                </Box>
              </Grid>
            </Grid>
          ) : (
            <Grid
              container
              sx={{
                mx: '5px',
                pl: '5px',
                pr: '25px',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
              direction="column"
            >
              <Grid container sx={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <Grid size="grow">
                  <CartProductDetails item={serviceItem} />
                </Grid>
                <Grid sx={{ width: '140px' }}>
                  <QuantityControl
                    count={serviceCount}
                    onAdd={addToBasket}
                    onRemove={removeFromBasket}
                    isEditable={item.removable}
                  />
                </Grid>
              </Grid>
              <Grid
                sx={{
                  height: 'auto',
                  color: 'black',
                  fontSize: '19px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
                  pr: '15px',
                  textAlign: 'right',
                }}
              >
                <CartProductPrice item={serviceItem} serviceCount={serviceCount} />
              </Grid>
            </Grid>
          )}
        </Card>
      )}
    </>
  );
}
